export const UnitProfileSaleDetailsComponentTabsData = [
  { tab: 'sales-details' },
  { tab: 'for-financial-team-use-only' },
  { tab: 'payment-plan-1' },
  { tab: 'payment-plan-2' },
];
